// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageWrapper_wrapper__jCboB"};